import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../redux/storeFunctions";

const RouteGuard = () => {
  const location = useLocation();
  const { token } = useAppSelector((state) => state.auth);

  if (!token) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  if (location.pathname === "/") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default RouteGuard;
